// fr_FR language file
// Generated from Feishu Bitable
// Total entries: 450

export default{
    "game_diamond": {
        "title": "Infos sur les diamants de jeu",
        "title0_title": "Comment obtenir des diamants de jeu",
        "title0": {
            "txt1": "1. Gagnez-les via des missions ou événements spécifiques.",
            "txt2": "2. Ne peuvent pas être achetés avec une recharge."
        },
        "title1_title": "Utilisation des diamants de jeu",
        "title1": {
            "txt1": "1. Utilisés uniquement pour les jeux.",
            "txt2": "2. Dans le jeu, les Diamants de Jeu sont équivalents aux diamants normaux et peuvent être utilisés directement. Les diamants gagnés avec des Diamants de Jeu sont des diamants normaux.",
            "txt3": "3. Les diamants de jeu sont utilisés en priorité.",
            "txt4": "4. Peut être combiné avec les diamants. Ex : 200 + 800 = 1000 utilisés."
        },
        "title2_title": "Validité des diamants de jeu",
        "title2": {
            "txt1": "1. Valables pour une durée limitée, puis récupérés par le système."
        }
    },
    "guanxi_gift_rule_title": "Descriptions des cadeaux",
    "guanxi_gift_rule_1": "Après avoir envoyé un cadeau relationnel, le destinataire peut choisir de nouer une relation avec vous. Il ne peut y avoir qu'une seule relation entre deux personnes à la fois.",
    "guanxi_gift_rule_2": "Chaque personne peut avoir jusqu'à 3 relations, et les types de relations peuvent être identiques.",
    "guanxi_gift_rule_3": "Vous pouvez mettre fin à une relation 24 heures après l'avoir établie. Après avoir mis fin à une relation, vous pouvez en former une nouvelle après 24 heures.",
    "not_exist": "Non trouvé",
    "mbti_intro_title": "Descriptions MBTI",
    "mbti_intro_pers": "Traits de personnalité",
    "mbti_intro_love": "Traits romantiques",
    "mbti_intro_istj_pers": "Personnalité d'inspecteur",
    "mbti_intro_istj_feature": "Sérieux, calmes, soucieux du détail et précis, ils préfèrent une vie ordonnée et structurée. Fiables et responsables, ils suivent les règles et les traditions.",
    "mbti_intro_istj_love": "En amour, les ISTJ sont des partenaires loyaux et stables. Ils prennent les relations au sérieux, se concentrant sur l'engagement et la responsabilité, montrant leur attention par des actions plutôt que par des mots, ayant besoin de temps pour former des liens profonds.",
    "mbti_intro_isfj_pers": "Personnalité de l'aidant",
    "mbti_intro_isfj_feature": "Doux, gentils et empathiques, ils sont attentifs aux besoins des autres et patients. Soucieux du détail, ils savent écouter et soutenir.",
    "mbti_intro_isfj_love": "Dans les relations, les ISFJ sont profondément attentionnés, attentifs aux détails de la vie de leur partenaire et créent une atmosphère confortable et chaleureuse. Souvent traditionnels, ils peuvent mettre du temps à s'engager mais sont très loyaux une fois qu'ils l'ont fait.",
    "mbti_intro_infj_pers": "Personnalité Architecte",
    "mbti_intro_infj_feature": "Perspicaces et créatifs, ils ont une compréhension profonde de l'humanité et de l'avenir. Ils ont une vie intérieure riche et sont réfléchis et analytiques.",
    "mbti_intro_infj_love": "Les INFJ recherchent une connexion mentale et émotionnelle avec leurs partenaires et apprécient les conversations profondes. Ils ont des idéaux élevés en amour et, lorsqu'ils sont amoureux, ils sont concentrés et dévoués.",
    "mbti_intro_intj_pers": "Personnalité de commandant",
    "mbti_intro_intj_feature": "Logiques, calmes et confiants, dotés de solides compétences analytiques et décisionnelles, ils apprécient le savoir et la sagesse et poursuivent leurs objectifs avec ténacité.",
    "mbti_intro_intj_love": "Dans les relations amoureuses, les INTJ abordent l'amour de façon rationnelle, en valorisant les croyances et les objectifs communs. Bien que réservés sur le plan émotionnel, ils manifestent leur attention par des actions réfléchies.",
    "mbti_intro_istp_pers": "Personnalité d'artisan",
    "mbti_intro_istp_feature": "Pratiques, observateurs et analytiques, ils aiment les tâches pratiques et la résolution de problèmes concrets, en particulier dans les domaines mécaniques ou techniques.",
    "mbti_intro_istp_love": "Les ISTP sont spontanés et libres dans leurs relations, appréciant le moment présent avec leur partenaire et partageant les plaisirs de la vie sans trop de restrictions.",
    "mbti_intro_isfp_pers": "Personnalité artistique",
    "mbti_intro_isfp_feature": "Sensibles, doux et artistes, ils privilégient les expériences émotionnelles et sensorielles, et s'expriment souvent par des formes créatives.",
    "mbti_intro_isfp_love": "Dans les relations, les ISFP sont romantiques et attentionnés, habiles à créer une atmosphère charmante, et ravissent souvent leurs partenaires avec des surprises. Ils peuvent être émotifs et ont besoin d'un partenaire qui les comprenne et les soutienne.",
    "mbti_intro_infp_pers": "Personnalité du médiateur",
    "mbti_intro_infp_feature": "Idéalistes, gentils et empathiques, ils ont une vie intérieure riche et une forte compréhension de la nature humaine, valorisant l'harmonie et la beauté.",
    "mbti_intro_infp_love": "Les INFP s'investissent profondément dans les relations, recherchant des liens émotionnels forts. Ils apprécient les échanges émotionnels et partagent une vision optimiste de l'amour.",
    "mbti_intro_intp_pers": "Personnalité Logicien",
    "mbti_intro_intp_feature": "Analytiques et curieux, ils ont un fort désir de connaissance, explorant des domaines inconnus à la recherche de la vérité.",
    "mbti_intro_intp_love": "Dans les relations, les INTP sont logiques et se concentrent sur la compatibilité intellectuelle et émotionnelle. Bien qu'ils puissent être réservés dans l'expression de leurs sentiments, ils utilisent les discussions pour favoriser la compréhension mutuelle.",
    "mbti_intro_estp_pers": "Personnalité entrepreneuriale",
    "mbti_intro_estp_feature": "Énergiques, extravertis et aventureux, ils aiment les interactions sociales et la prise de risque, saisissant activement les opportunités.",
    "mbti_intro_estp_love": "Dans leurs relations, les ESTP sont dynamiques et passionnées, aimant explorer de nouvelles expériences avec leur partenaire. Elles sont directes et expriment ouvertement leurs pensées et leurs sentiments.",
    "mbti_intro_esfp_pers": "Personnalité d'artiste",
    "mbti_intro_esfp_feature": "Extravertis, optimistes et expressifs, ils aiment les relations sociales et les divertissements, apportant énergie et enthousiasme.",
    "mbti_intro_esfp_love": "En amour, les ESFP sont des partenaires animés qui aiment partager des activités sociales, mettre l'accent sur les sentiments et les expériences présents, et apporter joie et excitation à leur partenaire.",
    "mbti_intro_enfp_pers": "Personnalité de campagne",
    "mbti_intro_enfp_feature": "Créatifs, énergiques et chaleureux, ils aiment s'engager avec les autres et comprennent profondément leurs émotions.",
    "mbti_intro_enfp_love": "Les ENFP sont comme le soleil dans les relations, apportant chaleur et joie à leurs partenaires. Pleins de romantisme, ils expriment activement leur amour et se réjouissent de créer de beaux souvenirs ensemble.",
    "mbti_intro_entp_pers": "Personnalité de débatteur",
    "mbti_intro_entp_feature": "Intelligents, pleins d'esprit et curieux, ils aiment débattre et explorer de nouvelles idées et de nouveaux sujets.",
    "mbti_intro_entp_love": "Les ENTP s'engagent dans des discussions et des débats profonds avec leurs partenaires, appréciant les défis et la croissance intellectuelle en amour. Souvent enjoués, ils apportent de l'humour à la relation.",
    "mbti_intro_estj_pers": "Personnalité exécutive",
    "mbti_intro_estj_feature": "Pratiques, décisifs et confiants, dotés de solides compétences en matière d'organisation et de leadership, ils accordent la priorité à l'efficacité et aux résultats.",
    "mbti_intro_estj_love": "En amour, les ESTJ s'affirment et sont déterminés, poursuivant activement leurs intérêts et planifiant l'avenir. Ils manifestent leur affection par un soutien et des actions concrètes.",
    "mbti_intro_esfj_pers": "Personnalité Consul",
    "mbti_intro_esfj_feature": "Amicaux et chaleureux, ils sont sociables et se soucient des autres, valorisant les traditions et les liens familiaux.",
    "mbti_intro_esfj_love": "Les ESFJ sont des partenaires attentifs et nourriciers, créant un environnement romantique harmonieux et chaleureux. Souvent traditionnels, ils apprécient les coutumes familières et l'approbation de la famille.",
    "mbti_intro_enfj_pers": "Personnalité Protagoniste",
    "mbti_intro_enfj_feature": "Charismatiques et confiants, ils se lient facilement et communiquent bien, comprenant et guidant efficacement les autres.",
    "mbti_intro_enfj_love": "Les ENFJ sont des partenaires enthousiastes et romantiques, exprimant ouvertement leur amour et créant une atmosphère chaleureuse. Ils apprécient les échanges émotionnels et cherchent à créer un lien profond avec leur partenaire.",
    "mbti_intro_entj_pers": "Personnalité exécutive",
    "mbti_intro_entj_feature": "Logiques, confiants et motivés, dotés de fortes capacités de leadership et de prise de décision, ils valorisent l'excellence et le succès, et ont des exigences élevées pour eux-mêmes et pour les autres.",
    "mbti_intro_entj_love": "En amour, les ENTJ sont orientés vers des objectifs, choisissant des partenaires qui partagent les mêmes idées et qui soutiennent le développement mutuel. Ils donnent la priorité à la compétence et aux ambitions communes, approfondissant les relations grâce à des objectifs partagés.",
    "expressProposalWall": "Règle du mur des propositions",
    "expressHowTo": "Comment figurer sur le mur des propositions",
    "expressSend": "Envoyez le cadeau de demande en mariage à votre amoureux(se) et votre texte d'expression de l'amour sera affiché sur le mur des propositions.",
    "expressSend1": "1) Appuyez sur \"Proposition maintenant\", vous pouvez sauter à la fête et sélectionner l'utilisateur pour envoyer vos mots d'amour.",
    "expressSend2": "2. sélectionnez le cadeau et saisissez les mots que vous voulez lui dire sur la carte.",
    "expressSend3": "3. touchez pour envoyer le cadeau et votre carte de demande en mariage s'affichera sur le mur.",
    "expressDifferent": "Différents types de cadeaux de demande en mariage",
    "expressWeHave": "Nous avons 4 types de cadeaux de demande en mariage comme suit.",
    "expressWeHave1": "1) Carte de demande en mariage de base : Fond de couleur simple.",
    "expressWeHave2": "2) Carte de demande en mariage décorative : Fond coloré décoratif.",
    "expressWeHave3": "3) Carte cadeau de luxe : Fond décoratif avec effet de luxe.",
    "expressWeHave4": "4. carte cadeau de demande d'amour véritable : Arrière-plan décoratif avec effet de luxe et barre de notification fantaisiste à l'échelle du serveur.",
    "expressProposal": "Gamme d'affichage des cartes de proposition",
    "expressProposal1": "1. mur des propositions dans la pièce (touchez la barre au-dessus des cadeaux de proposition)",
    "expressProposal2": "2. mur des propositions à côté de la page du moment.",
    "diamondDrop1": "1. Lorsqu'un utilisateur envoie des cadeaux totalisant plus de 50 000 diamants dans une pièce (les cadeaux chanceux sont calculés à 0,1 fois leur valeur), un coffre à diamants tombe que n'importe qui dans la pièce peut ouvrir pour s'emparer de diamants.",
    "diamondDrop2": "2. Chaque coffre dispose d'un compte à rebours d'une minute avant de pouvoir être ouvert.",
    "diamondDrop3": "3. Les diamants dans chaque coffre sont limités ; une fois le compte à rebours terminé, vous ne pouvez plus réclamer de diamants dans ce coffre.",
    "diamondDrop4": "4. Après la fermeture du coffre, vous pouvez cliquer pour voir combien de diamants vous avez récupérés.",
    "baoxaingxianding": "Limite des cadeaux au trésor",
    "cancelAccount": {
        "accountRecoveryContent": "Pendant la période de récupération, vous pouvez vous reconnecter en utilisant votre ancienne méthode et choisir de récupérer votre compte. Une fois récupéré, tu retrouveras tous les messages de ton compte, tes niveaux et tes diamants.",
        "accountRecoveryTitle": "Récupération de compte :",
        "confirmCancellation": "Êtes-vous sûr de vouloir supprimer votre compte ?",
        "convalescenceContent": "Après avoir soumis une demande de suppression, votre compte sera temporairement désactivé pendant 30 jours. Pendant cette période, toutes les informations de votre compte, vos niveaux et vos diamants seront conservés, ce qui vous permettra de récupérer votre compte si vous changez d'avis.",
        "convalescenceTitle": "Période de récupération :",
        "finalContent": "Si vous ne décidez pas de récupérer votre compte avant la fin de la période de récupération (31 jours à compter de la demande de suppression), votre compte et toutes les données associées seront définitivement supprimés. Veuillez noter qu'une fois supprimés, votre compte et vos données ne peuvent plus être récupérés.",
        "finalTitle": "Suppression définitive :",
        "reserveContent": "Pendant la période de récupération, nous protégerons les données de votre compte pour éviter qu'elles ne soient perdues ou endommagées.",
        "reserveTitle": "Conservation des données :",
        "statementContent": "Demande de suppression : Après avoir soumis une demande de suppression de compte, votre compte entrera dans une « période de récupération » de 30 jours. Pendant cette période, vous pouvez choisir de récupérer votre compte à tout moment. Si vous faites partie d'une agence, la suppression de votre compte ne sera pas possible.",
        "statementTitle": "Avis de suppression de compte :",
        "userContent": "Nous vous remercions d'avoir utilisé nos services. Nous comprenons que vous puissiez parfois avoir besoin de supprimer votre compte. Afin que votre décision soit mûrement réfléchie et que vous ayez la possibilité de reconsidérer votre décision, nous décrivons ici la procédure de suppression de compte et les conditions qui s'y rapportent.",
        "userTitle": "Cher utilisateur :"
    },
    "Countdown": "Compte à rebours",
    "Endactivity": "Événement terminé",
    "eventDetails": "Détails de l'événement",
    "eventGifts": "Cadeaux de l'événement",
    "eventList": "Classement de l'événement",
    "eventReward": "Récompenses de l'événement",
    "eventRewards": {
        "player": "Joueurs actifs quotidiens",
        "proportion": "Taux de retour des prix",
        "title": "Prix de l'événement",
        "txt1": "1. Les données de la veille sont calculées quotidiennement à 00h00 (UTC+8).",
        "txt2": "2. Les prix sont attribués en fonction du nombre de participants et des diamants réellement dépensés dans la salle (mises de l'utilisateur moins gains de l'utilisateur).",
        "txt3": "3. Les données de la semaine précédente sont calculées tous les lundis à 00h00 (UTC+8), et les récompenses sont distribuées dans les 3 jours.",
        "txt4": "4. Taux de retour des prix :",
        "txt5": "5. Définition du joueur actif : Un joueur qui mise plus de 1 000 diamants par jour."
    },
    "EventRules": "Règles de l'événement",
    "Eventtime": "Heure de l'événement",
    "guild": {
        "guild_certification01": "Vérification par l'Agence",
        "guild_certification02": "Agence d'accueil",
        "guild_certification03": "Conditions de recrutement",
        "guild_certification04": [
            "Avoir signé 10 ancres et s'être installé dans la semaine",
            "Être en mesure de fournir la carte d'identité du responsable de l'agence et d'autres documents relatifs à son nom",
            "Fournir un profil de l'agence, une présentation de l'équipe, des informations sur les ancres, des règles sur les revenus des ancres, etc."
        ],
        "guild_certification05": "Si vous répondez aux critères ci-dessus, envoyez vos informations à l'adresse officielle :",
        "guild_certification06": "Copié dans le presse-papiers",
        "guild_certification07": "Contact pour les demandes de renseignements",
        "guild_certification08": "Copie",
        "guild_certification09": "Informations sur l'adhésion",
        "guild_certification10": [
            {
                "title": "1. Règles d'adhésion",
                "value": [
                    "Les candidats doivent se mettre d'accord avec le responsable de l'agence pour initier une demande d'adhésion sur la plateforme. Une fois la demande approuvée par le chef d'agence, le candidat devient un ancrage signé, contribuant ainsi à l'agence."
                ]
            },
            {
                "title": "2. Règles de démission",
                "value": [
                    "Pour quitter l'agence après s'y être inscrit, l'animateur doit se mettre d'accord avec le responsable de l'agence. Cliquez sur « Quitter l'agence » sur la page de profil de l'agence. Le responsable de l'agence doit cliquer sur « Accepter de quitter », puis le membre quittera l'agence.",
                    "Une fois que le retrait a été effectué avec succès, vous pouvez demander à rejoindre une autre agence."
                ]
            }
        ],
        "guild_certification11": "Informations sur l'agence",
        "guild_certification12": [
            {
                "title": "Gains de l'agence",
                "value": [
                    "Les utilisateurs et les ancres des salles familiales reçoivent des cadeaux, ce qui génère des contributions à l'agence.",
                    "Les attaques de chef se produisent dans les salles familiales.",
                    "Les ancres signées avec l'agence créent des salles de CP, et le fait de recevoir des cadeaux génère des contributions à l'agence. (Les ancres non signées ne peuvent pas créer de salles de CP et générer des contributions familiales après avoir rejoint la famille)."
                ]
            }
        ],
        "InvitationCodeTitle": "Code d'invitation",
        "invite_rules_intriduction": "Règles d'invitation",
        "invite_rules_intriduction_content": [
            "Les ancres peuvent demander à rejoindre votre agence et devenir ancres en saisissant le code d'invitation lors de l'inscription.",
            "Les ancres qui n'ont pas saisi de code d'invitation lors de l'inscription peuvent demander à rejoindre votre famille via la page de la famille, puis demander à devenir une ancre."
        ]
    },
    "legend": {
        "title": "Février légendaire"
    },
    "officialMember": "Personnel officiel",
    "prettyNumber": {
        "text": "Ⅰ. Collection d'identifiants spéciaux",
        "text1": "Après avoir atteint le niveau de noblesse 3 ou plus, vous pouvez réclamer un identifiant spécial correspondant à votre niveau.",
        "text2": "Les nobles de niveau supérieur peuvent réclamer un ID spécial de niveau inférieur. Par exemple, un Noble 6 peut réclamer un ID spécial de niveau 3.",
        "text3": "Lorsque votre statut de noble expire, l'identifiant spécial devient également indisponible. Vous devez réactiver votre statut de noble pour continuer à utiliser l'identifiant spécial.",
        "text5": "Une fois que vous avez réclamé un identifiant spécial, vous ne pouvez pas l'échanger contre un autre identifiant du même niveau ou d'un niveau inférieur.",
        "text6": "Si vous atteignez un niveau de noblesse supérieur alors que vous utilisez un identifiant spécial, vous pouvez immédiatement passer à un identifiant spécial de niveau supérieur, et l'identifiant d'origine retournera dans le magasin.",
        "text7": "Par exemple, un utilisateur de Noble 4 qui réclame initialement un ID spécial de Noble 4 et qui passe ensuite à Noble 6 ne peut pas passer à un ID spécial de Noble 4 ou inférieur, mais peut immédiatement réclamer un ID spécial de Noble 6.",
        "title": "Explication",
        "title1": "Ⅱ. Expiration de l'ID spécial",
        "title2": "Ⅲ. Special ID Replacement"
    },
    "reception": {
        "reception01": "Gift Leaderboard Explanation",
        "reception02": [
            {
                "title": "Qu'est-ce que le Room Gift Leaderboard ?",
                "value": [
                    "Le tableau des cadeaux de la salle est un classement en temps réel des cadeaux reçus dans la salle",
                    "Nombre de cadeaux dans la chambre = Nombre de cadeaux dans le diamant"
                ]
            },
            {
                "title": "Quel est le classement du Room Gift Leaderboard ?",
                "value": [
                    "Le classement est déterminé en fonction du revenu total de toutes les chambres, calculé de manière exhaustive",
                    "Classement horaire : Remise à zéro toutes les heures à UMT+8",
                    "Classement quotidien : Remise à zéro à 00:00 UMT+8 tous les jours"
                ]
            },
            {
                "title": "Le top 1 du classement horaire est diffusé sur l'ensemble du serveur",
                "value": [
                    "Le top 1 du classement horaire des cadeaux est annoncé dans toutes les salles du serveur"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "Retour",
        "event_rule": "<p>1. Tableau de la durée : Ce classement indique le temps total passé par les utilisateurs dans toutes les positions de micro de la salle pendant l'événement. Les 3 meilleurs contributeurs dans les 3 meilleures salles recevront des récompenses.</p><p>2. Tableau de classement de la générosité : Indique le nombre total de diamants reçus dans la salle pendant l'événement. Les 3 personnes ayant dépensé le plus de diamants dans les 3 meilleures salles recevront des récompenses.</p><p>3. Cet événement se déroule sur un cycle hebdomadaire, le classement étant réinitialisé et recalculé chaque semaine.</p>",
        "last_week": "Semaine dernière",
        "last_week_rank": "Détails du classement de la semaine dernière",
        "reward": "Récompenses",
        "rich_rank": "Classement des cadeaux de salle",
        "rule": "Règles",
        "rule_reward": "Règles et récompenses",
        "time_rank": "Classement de la durée",
        "title": "Salle familiale",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "Cadre pour 14 jours",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png?t=1666610955",
        "top1_pictures_2_name": "Effets pour 14 jours",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "Cadre pour 14 jours",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "Cadre pour 7 jours",
        "top2": "TOP2",
        "top3": "TOP3"
    },
    "TopUpRewards": "Récompenses TopUp",
    "treasure_chest": {
        "title": "Instructions pour les coffres au trésor",
        "value1": "Il existe trois types de coffres au trésor : Bois, Argent et Or.",
        "value2": "Lorsque vous ouvrez un coffre au trésor, vous recevez un cadeau au hasard et vous l'envoyez.",
        "value3": "L'expéditeur gagne des points d'expérience en fonction des diamants dépensés, tandis que le destinataire reçoit des pièces et des points de charme en fonction de la valeur du cadeau.",
        "value4": "Le coffre en bois, dont le prix est de 1500 diamants, contient les cadeaux suivants :",
        "value5": "Le coffre en argent, dont le prix est de 7500 diamants, contient les cadeaux suivants :",
        "value6": "Le coffre en or, dont le prix est de 25 000 diamants, contient les cadeaux suivants :",
        "value7": "Les cadeaux du coffre au trésor sont uniquement destinés au divertissement et à l'interaction sociale. Toute action affectant l'équité ou exploitant les bogues des produits sera interdite. En cas de détection, la plateforme bannira le compte et se réserve le droit d'intenter une action en justice."
    },
    "treasure_name": {
        "name1": "Coffre en bois",
        "name2": "Coffre en argent",
        "name3": "Coffre en or",
        "name4": "Probabilité"
    },
    "Value": "Valeur :",
    "Webname": {
        "addUid": "Ajouter l'UID",
        "balance": "Solde :",
        "Confirm": "Confirmer",
        "err_uid": "UID invalide, veuillez le saisir à nouveau",
        "lang": "Sélectionner la langue",
        "Query": "Rechercher",
        "recharge": "Centre de recharge",
        "Recharge": "Recharger",
        "self": "Canal",
        "uid": "Changer d'UID",
        "uuserName": "Pseudonyme :",
        "Withdrawal": "Retirer"
    },
    "Weekly_Cp": {
        "7days": "7 jours",
        "back": "retour",
        "countdown": "Compte à rebours pour cette semaine",
        "day": "jours",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>Notes</p><p>1. Toutes les récompenses seront créditées sur votre compte dans les 3 à 5 jours ouvrables suivant la fin de l'événement.</p><p>2. Le classement calcule les diamants dépensés pour envoyer des cadeaux d'événement à d'autres utilisateurs. 1 diamant = 1 point de CP, et les 3 paires de CP les plus élevées recevront les récompenses de l'événement.</p><p>3. L'événement se termine tous les lundis à 00:00 (UTC+8), et les valeurs de la semaine précédente sont réglées.</p><p>4. Seuls 10% des diamants dépensés pour les cadeaux chanceux seront comptabilisés.</p>",
        "gift": "Cadeaux de l'événement",
        "hour": "Heure",
        "last_week": "Semaine dernière",
        "last_week_rank": "Liste de la semaine dernière",
        "minute": "Minute",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "récompenses",
        "rule": "règles",
        "rule_reward": "règles et récompenses",
        "seconds": "secondes",
        "title": "âme sœur",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "Cadre d'avatar de star de la semaine",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "cadre d'avatar de meilleur donation",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "tenu de star de la semaine",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "TOP2",
        "top2_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "TOP3",
        "top3_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "TOP 4-6",
        "top710": "TOP7-10"
    },
    "Withdrawal": "Instructions de retrait",
    "withdrawalInstructions": {
        "text1": "La fonction de retrait n'est actuellement disponible que dans certains pays.",
        "text2": "Le délai de traitement des retraits peut varier en fonction du canal.",
        "text3": "Le montant réel reçu peut être légèrement inférieur au montant affiché en raison des fluctuations des taux de change et des frais.",
        "text4": "Vous ne pouvez effectuer qu'un seul retrait par jour.",
        "text5": "Si vous rencontrez des problèmes, veuillez nous contacter."
    },
    "withdrawalLogin": {
        "accountId": "ID du compte Pix",
        "accountIdTips": "",
        "accountIdtsa": "L'ID du compte Pix ne peut pas être vide",
        "accountType": "Type de compte Pix",
        "code": "Code de vérification :",
        "Confirm": "Confirmer",
        "documentId": "Numéro d'identification personnel",
        "documentIdTips": "",
        "documentIdtsa": "Le type d'ID ne peut être vide",
        "documentType": "Type d'ID",
        "getAccount": "Obtenir un compte",
        "getUserId": "Veuillez saisir l'ID utilisateur",
        "incorrectAccount": "Compte incorrect",
        "login": "Connexion",
        "loginSuccessful": "Connexion réussie",
        "name": "Nom d'utilisateur Pix",
        "nameTips": "",
        "nametsa": "La longueur doit être comprise entre 5 et 100 caractères",
        "officialGroup": "Si vous avez des questions, veuillez contacter notre support officiel.",
        "pocket": "Solde de pièces de poche",
        "Pocket": "Solde de pièces de poche insuffisant",
        "Send": "Envoyer",
        "text": "Le code de vérification sera envoyé dans l'application",
        "title": "Retrait des gains",
        "title2": "Détails du retrait",
        "user_id": "ID du compte :",
        "Whatsapp": "Compte Whatsapp incorrect",
        "WhatsappTips": "",
        "applicationTime": "Date de demande",
        "amount": "Montant du retrait",
        "success": "Succès",
        "applicationSuccess": "Demande envoyée"
    },
    "top1AnchorRewards": "top1 récompenses de diffuseur",
    "top2_3AnchorRewards": "top2-3 récompenses de diffuseur",
    "top4_10AnchorRewards": "top4-10 récompenses de diffuseur",
    "top1Icon7day": "Cadre d'avatar*7j",
    "top1_2Icon7day": "Effet d'entrée*7j",
    "top3Icon7day": "Cadre d'avatar*7j",
    "top1VIPRewards": "Top 1 Récompenses de VIP",
    "top2_3VIPRewards": "Top 2-3 Récompenses de VIP",
    "top4_10VIPRewards": "Top 4-10 Récompenses de VIP",
    "relastionship": {
        "des": [
            "",
            "1. Après avoir offert un cadeau de relation, l’autre personne peut choisir d’établir ou non une relation avec vous. Une seule relation peut exister entre deux personnes.",
            "2. Dans les 7 jours calendaires (UTC+3) suivant l’établissement de la relation, le niveau d’intimité ne diminue pas. Après cette période, si l’intimité n’augmente pas de 50 points en une journée, elle diminue de 10 % à minuit (minimum 1). Quand elle atteint 0, la relation est rompue à minuit. Si aucune hausse de 50 points pendant 10 jours consécutifs, la relation se termine automatiquement.",
            "3. Vous pouvez rompre la relation 24 heures après l’avoir établie. Vous pouvez la rétablir 24 heures après la rupture.",
            "4. Chaque personne dispose par défaut de 3 emplacements de relation. Vous pouvez dépenser des diamants pour en acheter davantage (99 999 diamants par emplacement) jusqu’à 10 au total. Vous pouvez aussi en obtenir plus en augmentant votre niveau VIP.",
            "Niveau VIP",
            "Nombre total d’emplacements de relation extensibles"
        ]
    },
    "gift_album_des1": "Offrir les cadeaux ci-dessus peut l'aider à éclairer l'Album Hebdomadaire - \"Tour du Monde\" et à obtenir des récompenses.",
    "gift_album_des2": "Offrir les cadeaux ci-dessus peut l'aider à éclairer l'Album Permanent - \"Coup de Cœur\" et à obtenir des récompenses.",
    "gift_album_des3": "Offrir les cadeaux ci-dessus peut l'aider à éclairer l'Album Permanent - \"Garde SVIP\" et à obtenir des récompenses.",
    "gift_album_des4": "Offrir les cadeaux ci-dessus peut l'aider à éclairer l'Album Permanent - \"Mariage de Rêve\" et à obtenir des récompenses.",
    "gift_album_des5": "Accédez à [Profil] - [Mur de Cadeaux] - [Album] pour voir les détails",
    "gift_album_des8": "Offrir les cadeaux ci-dessus peut l’aider à activer la collection permanente – « Fête d’anniversaire » et à obtenir des récompenses.",
    "gift_album_des7": "Offrir les cadeaux ci-dessus peut l'aider à éclairer l'Album Permanent - \"Étoile de la salle\" et à obtenir des récompenses.",
    "gift_harifata": "Burj Khalifa",
    "gift_sailing_hotel": "Burj Al Arab",
    "gift_mosque": "a grande Mesquita",
    "gift_abatta": "Torre Abate",
    "gift_sphinx": "Esfinge",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "Amour Heartbeat",
    "gift_conf_lv2": "L'amour frappé",
    "gift_conf_lv3": "L'amour sans limite",
    "gift_conf_lv4": "Personne d'autre que toi",
    "gift_habibi": "Habibi",
    "gift_bestie": "Bestie",
    "gift_couple": "Couple",
    "gift_confidant": "Confidant",
    "weding_gift_kiss": "Baiser",
    "weding_gift_ring": "Bague",
    "weding_gift_proposal": "Demande en mariage",
    "weding_gift_castle": "Château",
    "weding_gift_wedding_dress": "Robe de mariée",
    "weding_gift_wedding": "Mariage",
    "gift_album_des6": "Règles",
    "guild_can_with": "Disponible",
    "guild_with_ing": "En cours de traitement",
    "guild_self_withdraw": "Retrait autonome",
    "guild_transfer_to_leader": "Transférer au chef d’agence",
    "guild_salary_to_reseller": "Transférer au revendeur",
    "guild_convert_to_diamond": "Convertir en diamants",
    "guild_platform_settlement": "Règlement de la plateforme",
    "guild_withdrawal_records": "Historique des retraits",
    "guild_current_withdrawable_pcoin": "Coins disponibles",
    "guild_transfer_pcoin_amount": "Montant à transférer",
    "guild_all": "Tout",
    "guild_read_before_withdraw": "À lire avant de retirer :",
    "guild_withdraw_note_1": "Envoyer",
    "guild_withdraw_note_2": "Solde insuffisant pour le retrait",
    "guild_min_withdraw_amount": "Confirmer l’envoi ?",
    "guild_withdraw_note_4": "Annuler",
    "guild_appeal_to_platform": "Confirmer",
    "guild_submit_application": "Méthode de retrait",
    "guild_withdraw_below_min": "Retrait du chef",
    "guild_confirm_submit_application": "Heure de la demande",
    "guild_freeze_notice": "Délai de traitement",
    "guild_communicate_with_leader": "Motif du refus",
    "guild_cancel": "Montant remboursé",
    "guild_confirm": "En attente",
    "guild_withdrawal_method": "Terminé",
    "guild_leader_withdraw": "Refusé",
    "guild_status_timeout_rejected": "Refus auto (délai dépassé)",
    "guild_apply_time": "3 derniers mois uniquement",
    "guild_process_time": "Des questions sur le retrait ?",
    "guild_rejection_reason": "Contacter l’assistance",
    "guild_amount_refunded": "Revendeur vérifié",
    "guild_status_pending": "Réservé aux revendeurs",
    "guild_status_completed": "Disponible",
    "guild_status_rejected": "Montant du transfert",
    "guild_show_last_3_months": "Arrivée estimée",
    "guild_withdrawal_question": "Réussi",
    "guild_contact_customer_service": "Convertir en diamants",
    "guild_certified_reseller": "Coins convertibles disponibles",
    "guild_not_reseller_cannot_transfer": "Convertir",
    "guild_current_withdrawable": "Converti",
    "guild_transfer_amount": "Coin réglé",
    "guild_estimated_arrival": "Demande envoyée",
    "guild_read_before_operation": "1. Veuillez confirmer à l’avance les détails du paiement hors ligne avec le revendeur",
    "guild_transfer_note_1": "2. Les transferts sont uniquement possibles vers un revendeur",
    "guild_transfer_note_2": "Confirmer le transfert",
    "guild_confirm_transfer": "Confirmer l’envoi ?",
    "guild_confirm_submit_transfer": "{n} pièces seront déduites",
    "guild_deduct_pcoin_receive_diamond": "Veuillez coordonner les détails du paiement avec le revendeur",
    "guild_communicate_with_reseller": "Transaction réussie",
    "guild_operation_success": "Convertir en diamants",
    "guild_exchange_diamond": "Coins convertibles disponibles",
    "guild_current_exchangeable_pcoin": "Convertir",
    "guild_exchange": "Conversion réussie",
    "guild_exchange_success": "Coins à régler",
    "guild_settlement_pcoin_amount": "1. Veuillez confirmer à l’avance la méthode de retrait avec l’équipe Opérations",
    "guild_settlement_note_1": "2. Les paiements seront traités lundi prochain",
    "guild_settlement_note_2": "3. Montant minimum de retrait : {n} coins",
    "guild_settlement_min_amount": "Demande envoyée",
    "guild_application_submitted": "{n} coins seront déduits",
    "guild_deduct_pcoin": "Veuillez coordonner les détails du paiement avec l’équipe Opérations",
    "guild_user_not": "Utilisateur introuvable",
    "guild_please_enter_amount": "Entrez le montant",
    "guild_insufficient_balance": "Solde insuffisant",
    "guild_please_enter_reseller_uid": "Entrez l’UID du RESELLER",
    "guild_please_search_reseller_first": "Veuillez d’abord rechercher le RESELLER",
    "guild_select_hand": "Sélectionnez une action",
    "guild_ci_hand": "1. Cette action soumettra une demande au chef de guilde,",
    "guild_offline_transfer_funds": "et le paiement sera effectué hors ligne par le chef",
    "guild_ci_hand_2": "2. Veuillez confirmer à l’avance le mode de paiement avec le chef (carte bancaire / USDT, etc.)",
    "guild_ci_hand_3": "3. Le montant minimum de retrait est de {n} Coins",
    "guild_ci_hand_4": "4. Si le chef confirme le paiement mais que vous ne l’avez pas reçu, conservez les échanges et",
    "guild_ci_hand_5": "soumettez une réclamation à la plateforme",
    "guild_ci_hand_6": "Le système bloquera {n} Coins jusqu’au traitement par le chef",
    "guild_ci_hand_7": "Veuillez confirmer le canal de retrait avec le chef ; le paiement est hors ligne",
    "guild_tips_1": "Coins retirable en dessous du minimum",
    "guild_contact_service": "Veuillez contacter l’équipe d’exploitation pour organiser le paiement",
    "guild_reseller_tips": "Vos pièces sont devenues les diamants de l’autre utilisateur. Contactez-le pour le paiement.",
    "gift_collection_detail_permanent_birthday": "Fête Anniversaire",
    "gift_collection_detail_permanent_roomstar": "Étoile de la salle",
    "gift_holy_sword": "Épée Sacrée",
    "gift_volcano": "Volcan",
    "gift_emperor_come_world": "L'Empereur d'Europe Vient au Monde",
    "gift_castle_of_love": "Château de l'Amour",
    "gift_Immortal_god_war": "Dieu Immortel de la Guerre",
    "gift_king_of_gods": "Roi des Dieux",
    "birthday_gift_cybergift": "Cadeau Cyber",
    "birthday_gift_wish": "Vœu de Lampe",
    "birthday_gift_cake": "Gâteau d'Or",
    "birthday_gift_lion": "Vœu du Lion",
    "birthday_gift_biggift": "Cadeau Luxe",
    "guild_reseller_tips": "Vos pièces sont devenues les diamants de l’autre utilisateur. Contactez-le pour le paiement.",
    "guild_page_fee": "Frais de $2 par retrait",
    "guild_page_saudi": "Arabie saoudite",
    "guild_page_morocco": "Maroc",
    "guild_page_bank": "Banque",
    "guild_page_name": "Nom (en anglais)",
    "guild_page_name_english": "Le nom doit être en anglais",
    "guild_page_bank_number": "Numéro de compte bancaire",
    "guild_page_enter": "Entrez un numéro de compte valide",
    "guild_page_address": "Adresse (en anglais)",
    "guild_page_address_english": "L'adresse doit être en anglais",
    "guild_page_country": "Pays/Région",
    "guild_page_holder_name": "Nom du titulaire du compte",
    "guild_page_sa": "Ex. : SA8200000000XXXXXXXXXXXX",
    "guild_page_format": "Format : Rue, Zone, Ville, État, Pays",
    "guild_page_minimum": "3. Le montant minimum de retrait est de {n} Coins"
}
